import React, { useState } from "react"
import ModalDeleteCompany from "../../../../Modal/ModalDeleteCompany"
import ModalEditCompanyStatus from "../../../../Modal/ModalEditCompanyStatus"
import { parseXPTable } from "./helpers/parseXPTable" // Importando a função parseXPTable
import "./../../AllCompanysTable.css"
import CustomTable from "components/Common/CustomTable"

const XPTable = ({
  dataArray,
  currentPage,
  setCurrentPage,
  setCompanySelected,
  setShowList,
}) => {
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false)
  const [isModalEditStatusOpen, setIsModalEditStatusOpen] = useState(false)
  const [companyToEdit, setCompanyToEdit] = useState()

  const handleSelectCompanyToEditStatus = company => {
    setCompanyToEdit(company)
    setIsModalEditStatusOpen(true)
  }

  const handleSelectCompanyToDelete = company => {
    setCompanyToEdit(company)
    setIsModalDeleteOpen(true)
  }

  const handleSelectCompany = company => {
    setCompanySelected(company)
    setShowList(null)
  }

  return (
    <div className="company-table-container">
      {isModalDeleteOpen && (
        <ModalDeleteCompany
          companyId={companyToEdit.Id}
          urlTo={"xp"}
          setIsModalOpen={setIsModalDeleteOpen}
          setCurrentPage={setCurrentPage}
        />
      )}
      {isModalEditStatusOpen && (
        <ModalEditCompanyStatus
          urlTo={"xp"}
          setCurrentPage={setCurrentPage}
          setIsModalOpen={setIsModalEditStatusOpen}
          companySelected={companyToEdit}
        />
      )}

      <CustomTable
        data={parseXPTable({
          data: dataArray,
          onStatusClick: handleSelectCompanyToEditStatus,
          onEditClick: handleSelectCompany,
          onDeleteClick: handleSelectCompanyToDelete,
        })}
        pagination={{
          currentPage,
          onPageChange: setCurrentPage,
          totalPages: 10, // Ajuste conforme necessário
        }}
        autoHeight
      />
    </div>
  )
}

export default XPTable
